import { useEffect, useState } from 'react'
import { checkFile, databaseDateToFilename } from '../Utilities'

// Finds the first and last available image for a camera by HEAD-checking up to `maxTries` candidates from each end of the archive list.
// imagesList: archive tuple [orderedArray, lookupDict]; cameraId: camera index; cameraUrl: download base URL.
// Returns { firstImageUrl, lastImageDate, showCompare, setShowCompare }.
export function useImageAvailable(imagesList, cameraId, cameraUrl) {
    const [firstImageUrl, setFirstImageUrl] = useState(null)
    const [lastImageDate, setLastImageDate] = useState(null)
    const [showCompare, setShowCompare] = useState(false)

    useEffect(() => {
        let cancelled = false
        setFirstImageUrl(null)
        setLastImageDate(null)
        setShowCompare(false)

        const entries = imagesList?.[0]?.filter(elem => elem?.[1]?.[cameraId]?.datum) || []
        if (!cameraUrl || entries.length === 0) return

        const maxTries = 10

        async function findFirstImage() {
            for (let i = 0; i < Math.min(entries.length, maxTries); i++) {
                const date = entries[i][1][cameraId].datum
                const url = cameraUrl + databaseDateToFilename(date)
                const { exists, contentType } = await checkFile(url)
                if (cancelled) return
                if (exists && contentType === 'image') { setFirstImageUrl(url); return }
            }
        }

        async function findLastImage() {
            for (let i = entries.length - 1; i >= Math.max(0, entries.length - maxTries); i--) {
                const date = entries[i][1][cameraId].datum
                const url = cameraUrl + databaseDateToFilename(date)
                const { exists, contentType } = await checkFile(url)
                if (cancelled) return
                if (exists && contentType === 'image') { setLastImageDate(date); return }
            }
        }

        findFirstImage()
        findLastImage()

        return () => { cancelled = true }
    }, [imagesList, cameraId, cameraUrl])

    return { firstImageUrl, lastImageDate, showCompare, setShowCompare }
}
